import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { syncPushAccount } from "@/lib/webPush";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking session, false = guest, object = authenticated user
  const [user, setUser] = useState(null);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    setUser(data);
    // Account switch: rebind any existing device push subscription to this account.
    syncPushAccount();
    return data;
  }, []);

  const register = useCallback(async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    syncPushAccount();
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // already logged out
    }
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function dashboardPath(role) {
  if (role === "admin") return "/admin";
  if (role === "ib") return "/ib";
  return "/member";
}
